import http from "../../shared/http"

const fields = {
    state: {
        config: [],
        userConfig: []
    },
    actions: {
        field_DateTime_unavailableTime({ commit, dispatch }, payload) {
            return dispatch('fetchComponentsModels', payload)
        },

        field_Date_disabledDates({ commit, dispatch }, payload) {
            return dispatch('fetchComponentsModels', payload)
        },

        field_DateRange_disabledDates({ commit, dispatch }, payload) {
            return dispatch('fetchComponentsModels', payload)
        },
        
    },
    mutations: {},
    getters: {}
  }

export default fields